export const POLL_STATES = {
  hide: 0,
  showQuestion: 1,
  showResult: 2,
  delete: 3,
};
export const POLL_TYPES = {
  NORMAL: "normal",
  QUIZ: "quiz",
  PRIORITY: "priority",
};
